export default __webpack_public_path__ + "static/media/slowdeathstrike3.65d960fa.png";